/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import LoginView from '../view/pages/public/LoginView'
import LoginStore from '../store/LoginStore'
import history from '../util/history'
import LoginAction from '../action/login'

class LoginContainer extends Component {
  static getStores() {
    return [LoginStore]
  }

  static calculateState(prevState, props) {
    return {
      login: LoginStore.getState(),
      ...props
    }
  }

  getQuery() {
    const params = window.location.search.substring(1).split('&')
    return params.reduce((acc, cur) => {
      const v = cur.split('=')
      const key = v[0]
      acc[key] = decodeURI(v[1])
      return acc
    }, {})
  }

  getProperty(obj, name) {
    return Object.prototype.hasOwnProperty.call(obj, name) ? obj[name] : null
  }

  componentDidMount() {
    const referrer = _.propertyOf(this.state.location.state)('referrer')
    if (referrer) {
      LoginAction.updateReferrer(referrer.pathname)
    } else {
      // Redirect Mapping
      const query = this.getQuery()
      const redirect = this.getProperty(query, 'redirect')
      if (redirect) {
        history.replace(redirect)
      }
    }
  }

  render() {
    return LoginView(this.state)
  }
}

export default withRouter(Container.create(LoginContainer, { withProps: true }))
